import { Box, ModalHeader, useColorModeValue } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { headingFont } from 'theme/tokens';

interface ModalHeaderAccentProps {
	children: ReactNode;
	/** Accent color — maps to Chakra color tokens */
	colorScheme?: 'brand' | 'accent' | 'danger' | 'warning';
}

const gradientMap = {
	brand: { light: 'linear-gradient(135deg, #023F7F 0%, #3578BF 100%)', dark: 'linear-gradient(135deg, #3578BF 0%, #6D9FD3 100%)' },
	accent: { light: 'linear-gradient(135deg, #059669 0%, #10B981 100%)', dark: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)' },
	danger: { light: 'linear-gradient(135deg, #DC2626 0%, #EF4444 100%)', dark: 'linear-gradient(135deg, #EF4444 0%, #F87171 100%)' },
	warning: { light: 'linear-gradient(135deg, #D97706 0%, #F59E0B 100%)', dark: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)' },
};

export default function ModalHeaderAccent({
	children,
	colorScheme = 'brand',
}: ModalHeaderAccentProps) {
	const gradients = gradientMap[colorScheme];
	const gradient = useColorModeValue(gradients.light, gradients.dark);

	return (
		<>
			<Box
				h="4px"
				bg={gradient}
				borderTopRadius="inherit"
			/>
			<ModalHeader fontFamily={headingFont} fontWeight="700" fontSize="lg">
				{children}
			</ModalHeader>
		</>
	);
}
